import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';

const isFormEmpty = (control: AbstractControl | null | undefined): boolean => {
  if (!control) {
    return true;
  }

  if (control instanceof FormControl) {
    const isEmpty = (value: unknown) =>
      value === null || value === undefined || (typeof value === 'string' && value.trim() === '');

    if (control.value instanceof Object) {
      return Object.values(control.value).every(value => isEmpty(value));
    }

    const value = control.value;

    return isEmpty(value);
  }

  if (control instanceof FormGroup) {
    return Object.values(control.controls).every(childControl => isFormEmpty(childControl));
  }

  if (control instanceof FormArray) {
    return control.controls.every(childControl => isFormEmpty(childControl));
  }

  return true;
};

const markAllControlsAsDirty = (abstractControls: AbstractControl[]): void => {
  abstractControls.forEach(abstractControl => {
    if (abstractControl instanceof FormControl) {
      (abstractControl as FormControl).markAsDirty({ onlySelf: true });
    } else if (abstractControl instanceof FormGroup) {
      markAllControlsAsDirty(Object.values((abstractControl as FormGroup).controls));
    } else if (abstractControl instanceof FormArray) {
      markAllControlsAsDirty((abstractControl as FormArray).controls);
    }
  });
};

const markAllControlsInFormAsDirty = (formGroup: FormGroup): void => {
  Object.keys(formGroup.controls).forEach(key => {
    const control = formGroup.get(key);
    if (control instanceof FormControl) {
      control.markAsDirty();
    } else if (control instanceof FormGroup) {
      markAllControlsInFormAsDirty(control);
    } else if (control instanceof FormArray) {
      control.controls.forEach(nestedControl => {
        if (nestedControl instanceof FormGroup) {
          markAllControlsInFormAsDirty(nestedControl);
        } else {
          nestedControl.markAsDirty();
        }
      });
    }
  });
};

export const FormUtils = {
  isFormEmpty,
  markAllControlsAsDirty,
  markAllControlsInFormAsDirty,
};
